const Apple = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <circle cx="28" cy="28" r="28" fill="#1B1B1B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2572 28.1111C34.228 25.3031 36.625 23.9562 36.732 23.8885C35.3852 21.9838 33.2866 21.7224 32.5394 21.693C30.7553 21.5173 29.0559 22.7093 28.1503 22.7093C27.2471 22.7093 25.8484 21.7185 24.3687 21.7435C22.4217 21.7717 20.6276 22.8387 19.6256 24.5239C17.604 27.9149 19.1087 32.9409 21.0785 35.6935C22.0418 37.0387 23.1902 38.5527 24.6968 38.4972C26.1492 38.4418 26.6976 37.5886 28.453 37.5886C30.2084 37.5886 30.7017 38.4972 32.2379 38.4687C33.7994 38.4413 34.7896 37.0976 35.7451 35.7468C36.8504 34.184 37.3058 32.6708 37.3327 32.5938C37.2989 32.5788 34.2884 31.4634 34.2572 28.1111ZM31.3705 19.8713C32.1695 18.9333 32.7109 17.6296 32.564 16.332C31.4106 16.3773 30.0145 17.0734 29.1868 18.0106C28.4451 18.8422 27.7964 20.1661 27.9701 21.4403C29.2564 21.5367 30.5687 20.8076 31.3705 19.8713Z"
        fill="white"
      />
    </svg>
  );
};

export default Apple;
